export default __webpack_public_path__ + "static/media/CasaCubaBG.20c73c0a.jpg";